import { isCommunityAccessDeniedError } from "./community"
import { isProjectUnavailableError } from "./project"

// React Query's own default.
const MAX_ATTEMPTS = 3

// A refusal is a verdict, not a hiccup: retrying one only spams the backend
// and delays the access-denied screen by three dead round trips.
export const shouldRetryRequest = (
  failureCount: number,
  error: unknown,
): boolean =>
  !isCommunityAccessDeniedError(error) &&
  !isProjectUnavailableError(error) &&
  failureCount < MAX_ATTEMPTS
